import userChannelNames from '../../consts/auth/userChannelNames';
import connectionTypes from '../../consts/connectionTypes';
import {IAP_FEATURES_CODES} from '../../consts/iap/iapFeatureCodes';

// Same shape as groupsConfig, per channel.
export default {
    [userChannelNames.COACH]: {[IAP_FEATURES_CODES.DASHBOARD]: null},
    [userChannelNames.CONSUMER]: {[IAP_FEATURES_CODES.SETUP]: [connectionTypes.WIFI, connectionTypes.CELLULAR]},
};
